import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Head from "next/head";
import { environmentVariables } from "@/components/ReadContent";
import spinner from "../public/icons/svg/duotone/spinner-third.svg";
import Image from "next/image";

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  message: Yup.string().min(10, "Too Short!").required("Required"),
});

export default function Contact() {
  const [isLoading, setIsLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },
    validationSchema: ContactSchema,
    onSubmit: (values) => {
      setIsLoading(true);
      // Handle submission, for example:
      // call an API to send the contact form data
      console.log(values);
      // alert("Form submitted! Check the console for data.");
      setTimeout(() => {
        setIsLoading(false);
      }, 5000);
    },
  });

  function isAnyFieldEmpty() {
    return !formik.values.name || !formik.values.email || !formik.values.message;
  };  

  return (
    <div className="px-10 sm:px-20 md:px-32 md:-mb-52 lg:mb-0 lg:px-60 mx-auto max-w-[75rem]">
      <Head>
        <title>{environmentVariables.contactTitle}</title>
        <link rel="icon" href="/favicon.png" />
      </Head>
      <main className="min-h-screen max-w-screen">
        <div className="pt-24 flex flex-col items-cen mx-auto">
          <h2
            className={
              "selection:text-black/40 dark:selection:text-white/40 font-deca bg-gradient-to-tr from-yellow-400 to-indigo-500 bg-clip-text text-transparent items-center mx-auto text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold"
            }
          >
            {environmentVariables.contact}
          </h2>

          <form name="contact" method="POST" data-netlify="true" action="/thankYou"
            onSubmit={(e) => {
              formik.handleSubmit();
            }}
          >
            <input type="hidden" name="form-name" value="contact" />

            <div className="mb-4">
              <div className="flex items-center justify-between">
                <label htmlFor="name" className="block mb-2 font-medium">
                  {environmentVariables.name}
                </label>
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-red-500 mb-2 font-medium">{formik.errors.name}</div>
                ) : null}
              </div>
              <input
                id="name"
                type="text"
                className="w-full px-4 py-2 border rounded dark:border-0"
                autoComplete="off"
                {...formik.getFieldProps("name")}
              />
            </div>

            <div className="mb-4">
              <div className="flex items-center justify-between">
                <label htmlFor="email" className="block mb-2 font-medium">
                  {environmentVariables.email}
                </label>
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-red-500 mb-2 font-medium">{formik.errors.email}</div>
                ) : null}
              </div>
              <input
                id="email"
                type="email"
                className="w-full px-4 py-2 border rounded dark:border-0"
                autoComplete="off"
                {...formik.getFieldProps("email")}
              />
            </div>

            <div className="mb-4">
              <div className="flex items-center justify-between">
                <label htmlFor="message" className="block mb-2 font-medium">
                  {environmentVariables.message}
                </label>
                {formik.touched.message && formik.errors.message ? (
                  <div className="text-red-500 mb-2 font-medium">{formik.errors.message}</div>
                ) : null}
              </div>
              <textarea
                id="message"
                className="w-full px-4 py-2 border rounded dark:border-0"
                rows="5"
                {...formik.getFieldProps("message")}
              />
            </div>

            <button
              type="submit"
              className={`px-6 py-2 bg-blue-500 text-white rounded ${isAnyFieldEmpty()  || isLoading ? 'opacity-50 cursor-not-allowed' : ''} flex items-center justify-center`}
              disabled={isAnyFieldEmpty() || isLoading}
            >
              {isLoading ? ( <Image src={spinner} alt="spinner" width={16} height={16} className="spinner-img animate-spin" /> 
              ) : ("")}
             &nbsp; {environmentVariables.submit}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
